<template>
  <div class="clientsAdd">
    <div class="pageContent">
      <heading type="h1">Edit User</heading>
      <spinner v-if="loading" />
      <client-logo :path="user.logo"/>
      <div class="row">
        <div class="col-sm-2">
          <upload-file name="Upload Logo" :ctaText="uploadLogoText" @input="onUploadLogo" acceptedFileType="image/*"/>
        </div>
        <div v-if="hasLogo" class="col-sm-2 clientsEdit__removeLogo">
          <button-cta :onClick="removeLogo">Remove logo</button-cta>
        </div>
      </div>
      <user-form :user="user" :submit="save" @loading="onLoadingStatus" />
    </div>
  </div>
</template>

<script>
import Heading from '@/components/Heading/heading'
import ButtonCta from '@/components/Button/button'
import Spinner from '@/components/SpinnerIcon/spinner'
import UserForm from '@/components/UserForm/user-form'
import ClientLogo from '@/components/ClientLogo/client-logo'
import UploadFile from '@/components/UploadFile/upload-file'
import {userMixin} from '@/mixins/userMixin'
import {profileMixin} from '@/mixins/profileMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import {pageMixin} from '@/mixins/pageMixin'

export default {
  name: 'UsersEdit',
  mixins: [userMixin, profileMixin, notificationMixin, pageMixin],
  components: {
    Heading,
    ButtonCta,
    Spinner,
    UserForm,
    ClientLogo,
    UploadFile
  },
  data: () => ({
    loading: false,
    clientNew: {
      currency: 'gbp'
    }
  }),
  computed: {
    uploadLogoText () {
      return `${this.user && this.user.logo ? 'Change' : 'Upload'} logo`
    },
    hasLogo () {
      return this.user.logo && this.user.logo.length > 0
    }
  },
  methods: {
    add () {
      this.loading = true
    },
    save () {
      this.loading = true
      console.log('this.user', this.user)
      this.updateUser(this.user).then(() => {
        this.addNotification('success', `'${this.user.name} user' Successfully updated.`)
        this.loading = false
      }, error => {
        this.loading = false
        this.addNotification('danger', error)
      })
    },
    onUploadLogo (e) {
      this.loading = true
      const files = e.target.files || e.dataTransfer.files
      const formData = new FormData()
      formData.append('file', files[0])
      const data = {
        id: this.user.hash_id,
        file: formData
      }
      this.uploadLogo(data).then(() => {
        this.getUser(this.user.hash_id).then(() => {
          this.getCurrentUser().then(() => {
            this.addNotification('success', 'Logo successfully uploaded.')
            this.loading = false
          }, error => {
            this.loading = false
            this.addNotification('danger', error)
          })
        }, error => {
          this.loading = false
          this.addNotification('danger', error)
        })
      }, error => {
        this.loading = false
        this.addNotification('danger', error)
      })
    },
    removeLogo () {
      this.loading = true
      this.deleteLogo(this.user.hash_id).then(() => {
        this.getUser(this.user.hash_id).then(() => {
          this.getCurrentUser().then(() => {
            this.addNotification('success', 'Logo successfully uploaded.')
            this.loading = false
          }, error => {
            this.loading = false
            this.addNotification('danger', error)
          })
        }, error => {
          this.loading = false
          this.addNotification('danger', error)
        })
      }, error => {
        this.loading = false
        this.addNotification('danger', error)
      })
    }
  },
  created () {
    this.loading = true
    this.getUser(this.$route.params.id).then(() => {
      console.log('Single user loaded', this.user)
    })
  }
}
</script>

<style lang="scss">
    .usersEdit {
    }
</style>



// WEBPACK FOOTER //
// src/pages/user/users-edit.vue